import useMediaQuery from '../hooks/useMediaQuery';

// 1024px is the lg breakpoint.
function useIsDesktop() {
  return useMediaQuery('(min-width: 1024px)');
}

export default useIsDesktop;
